module.exports = __webpack_public_path__ + "public/Icons/22Managecurrency.svg?ce654ff0";